import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import RGBColorPicker from "./color-pickers/RGBColorPicker";
import "./Rgb.css";
import LinearSlider from "./Sliders/LinearSlider";
import { Context } from "../../context/Context";
import {
  DeleteEquipments,
  UpdateEquipmentButton,
  UpdateEquipments,
} from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import { MqttContext } from "../../context/MQTTContext";
import WarningAlert from "../sweeAlerts/WarningAlert";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const RGB = ({ equipment_id }) => {
  const {
    authUser,
    setIsLoading,
    equipmentButtons,
    devices,
    setEquipmentButtons,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    setChangeNameOptions,
    handleChangeNameModal,
    selectedEquipment,
    update,
    refreshMqtt,
    currentRoom,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);
  const [buttons, setButtons] = useState([]);
  const [buttonStates, setButtonStates] = useState({});
  const [editButton, setEditButton] = useState(null);
  const [editedButtonName, setEditedButtonName] = useState("");
  const [changeColor, setChangeColor] = useState(false);
  const [changeBrightness, setChangeBrightness] = useState(false);
  const [changeSpeed, setChangeSpeed] = useState(false);
  const [sendMessage, setSendMessage] = useState(true);
  const [editEquipmentName, setEditEquipmentName] = useState(false);
  const [editedEquipmentName, setEditedEquipmentName] = useState("");

  const navigate = useNavigate();

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  // Refs to store the latest values of buttonStates and buttons
  const buttonsRef = useRef(buttons);
  const buttonStatesRef = useRef(buttonStates);
  useEffect(() => {
    buttonsRef.current = buttons;
    buttonStatesRef.current = buttonStates;
  }, [buttons, buttonStates]);

  useEffect(() => {
    let btns = equipmentButtons
      .filter((eq_btn) => eq_btn.equipment_id == eq_id)
      .map((btn) => ({
        ...btn,
        digit: Number(btn.digit),
      }));

    setButtons(btns);
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
    if (btns.length) {
      let clientsId = [];
      btns.forEach((button) => {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        if (
          device.is_bus == 1 &&
          clients[device?.bridge_device?.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ===
                endOfTwoCharToken &&
              device.serial === deviceSerial &&
              (message[10] == 1 || message[10] == 3) &&
              message[2] == 14
            ) {
              setButtonStates({
                0: message[11],
                1: message[12],
                2: message[13],
                3: message[14],
                4: message[15],
                5: message[16],
                rgbSpeed1: message[17],
                rgbSpeed2: message[18],
                rgbBrightness1: message[19],
                rgbBrightness2: message[20],
                audioEffect: message[21],
              });
            }
            setSendMessage(false);
          };

          // clients[device.bridge_device.id].removeAllListeners("message");
          clients[device.bridge_device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(10);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          asciiCode[8] = 3;
          asciiCode[9] = 0;

          let message = device.bridge_device.internet_token;

          // ترکیب رشته و بافر
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
          clientsId = [...clientsId, device.id];
        } else if (
          device.id &&
          device.username &&
          device.password &&
          clients[device.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              (message[2] == 1 || message[2] == 3)
            ) {
              setButtonStates({
                0: message[3],
                1: message[4],
                2: message[5],
                3: message[6],
                4: message[7],
                5: message[8],
                rgbSpeed1: message[9],
                rgbSpeed2: message[10],
                rgbBrightness1: message[11],
                rgbBrightness2: message[12],
                audioEffect: message[13],
              });
            }
            setSendMessage(false);
          };

          // clients[device.id].removeAllListeners("message");
          clients[device.id].on("message", messageListener);

          const decimalArray = [3, 0];
          const asciiArray = decimalArray.map((num) =>
            String.fromCharCode(num),
          );

          clients[device.id].publish(
            device.serial + "/sys",
            device.internet_token + asciiArray.join(""),
          );
          clientsId = [...clientsId, device.id];

          // Clean up the client when the component unmounts or re-renders
          return () => {
            clients[device.id].removeListener("message", messageListener); // Remove message listener
          };
        }
      });

      return () => {
        btns.forEach((button) => {
          let device = devices.find((d) => d.id == button.device_id);
          if (!device) {
            return;
          }
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            clients[device.bridge_device.id].removeAllListeners("message");
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            clients[device.id].removeAllListeners("message");
          }
        });
      };
    }
  }, [update, equipmentButtons, refreshMqtt, eq_id]);

  useEffect(() => {
    if (buttons.length) {
      let device = devices.find((d) => d.id == buttons[0].device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
        let buffer = new ArrayBuffer(20);
        let asciiCode = new Uint8Array(buffer);
        let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
        if (buttons[0].digit == 0) {
          selectedChannel = ["0", "0", "0", "0", "0", "1", "1", "1"];
        } else if (buttons[0].digit == 1) {
          selectedChannel = ["0", "0", "1", "1", "1", "0", "0", "0"];
        }
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = parseInt(selectedChannel.join(""), 2);
        asciiCode[10] = buttonStates[0];
        asciiCode[11] = buttonStates[1];
        asciiCode[12] = buttonStates[2];
        asciiCode[13] = buttonStates[3];
        asciiCode[14] = buttonStates[4];
        asciiCode[15] = buttonStates[5];
        asciiCode[16] = 101;
        asciiCode[17] = 101;
        asciiCode[18] = 101;
        asciiCode[19] = 101;

        let message = buttons[0].device.bridge_device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else if (clients[device.id]) {
        let buffer = new ArrayBuffer(12);
        let asciiCode = new Uint8Array(buffer);
        let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
        if (buttons[0].digit == 0) {
          selectedChannel = ["0", "0", "0", "0", "0", "1", "1", "1"];
        } else if (buttons[0].digit == 1) {
          selectedChannel = ["0", "0", "1", "1", "1", "0", "0", "0"];
        }
        asciiCode[0] = 1;
        asciiCode[1] = parseInt(selectedChannel.join(""), 2);
        asciiCode[2] = buttonStates[0];
        asciiCode[3] = buttonStates[1];
        asciiCode[4] = buttonStates[2];
        asciiCode[5] = buttonStates[3];
        asciiCode[6] = buttonStates[4];
        asciiCode[7] = buttonStates[5];
        asciiCode[8] = 101;
        asciiCode[9] = 101;
        asciiCode[10] = 101;
        asciiCode[11] = 101;

        let message = device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    }
  }, [changeColor]);

  useEffect(() => {
    if (buttons.length) {
      let device = devices.find((d) => d.id == buttons[0].device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
        let buffer = new ArrayBuffer(20);
        let asciiCode = new Uint8Array(buffer);
        let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = parseInt(selectedChannel.join(""), 2);
        asciiCode[10] = buttonStates[0];
        asciiCode[11] = buttonStates[1];
        asciiCode[12] = buttonStates[2];
        asciiCode[13] = buttonStates[3];
        asciiCode[14] = buttonStates[4];
        asciiCode[15] = buttonStates[5];
        asciiCode[16] = 101;
        asciiCode[17] = 101;
        asciiCode[18] =
          buttons[0].digit == 0 ? buttonStates.rgbBrightness1 : 101;
        asciiCode[19] =
          buttons[0].digit == 1 ? buttonStates.rgbBrightness2 : 101;

        let message = device.bridge_device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else if (clients[device.id]) {
        let buffer = new ArrayBuffer(12);
        let asciiCode = new Uint8Array(buffer);
        let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
        asciiCode[0] = 1;
        asciiCode[1] = parseInt(selectedChannel.join(""), 2);
        asciiCode[2] = buttonStates[0];
        asciiCode[3] = buttonStates[1];
        asciiCode[4] = buttonStates[2];
        asciiCode[5] = buttonStates[3];
        asciiCode[6] = buttonStates[4];
        asciiCode[7] = buttonStates[5];
        asciiCode[8] = 101;
        asciiCode[9] = 101;
        asciiCode[10] =
          buttons[0].digit == 0 ? buttonStates.rgbBrightness1 : 101;
        asciiCode[11] =
          buttons[0].digit == 1 ? buttonStates.rgbBrightness2 : 101;

        let message = device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    }
  }, [changeBrightness]);

  useEffect(() => {
    if (buttons.length) {
      let device = devices.find((d) => d.id == buttons[0].device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
        let buffer = new ArrayBuffer(20);
        let asciiCode = new Uint8Array(buffer);
        let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = parseInt(selectedChannel.join(""), 2);
        asciiCode[10] = buttonStates[0];
        asciiCode[11] = buttonStates[1];
        asciiCode[12] = buttonStates[2];
        asciiCode[13] = buttonStates[3];
        asciiCode[14] = buttonStates[4];
        asciiCode[15] = buttonStates[5];
        asciiCode[16] = buttons[0].digit == 0 ? buttonStates.rgbSpeed1 : 101;
        asciiCode[17] = buttons[0].digit == 1 ? buttonStates.rgbSpeed2 : 101;
        asciiCode[18] = 101;
        asciiCode[19] = 101;

        let message = device.bridge_device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else if (clients[device.id]) {
        let buffer = new ArrayBuffer(12);
        let asciiCode = new Uint8Array(buffer);
        let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
        asciiCode[0] = 1;
        asciiCode[1] = parseInt(selectedChannel.join(""), 2);
        asciiCode[2] = buttonStates[0];
        asciiCode[3] = buttonStates[1];
        asciiCode[4] = buttonStates[2];
        asciiCode[5] = buttonStates[3];
        asciiCode[6] = buttonStates[4];
        asciiCode[7] = buttonStates[5];
        asciiCode[8] = buttons[0].digit == 0 ? buttonStates.rgbSpeed1 : 101;
        asciiCode[9] = buttons[0].digit == 1 ? buttonStates.rgbSpeed2 : 101;
        asciiCode[10] = 101;
        asciiCode[11] = 101;

        let message = device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    }
  }, [changeSpeed]);

  const handleClickChangeColor = (red, green, blue) => {
    if (buttons?.[0]?.digit == 0 ?? false) {
      setButtonStates((prev) => ({
        ...prev,
        0: red,
        1: green,
        2: blue,
      }));
    } else if (buttons?.[0]?.digit == 1 ?? false) {
      setButtonStates((prev) => ({
        ...prev,
        3: red,
        4: green,
        5: blue,
      }));
    }
    setSendMessage(true);
    setChangeColor((prev) => !prev);
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleChangeBrightness = (value) => {
    const buttons = buttonsRef.current; // get latest buttons value
    const key =
      buttons?.[0]?.digit === 0
        ? "rgbBrightness1"
        : buttons?.[0]?.digit === 1
          ? "rgbBrightness2"
          : null;
    if (key) {
      setButtonStates((prev) => ({
        ...buttonStatesRef.current,
        [key]: Number(value),
      }));
      setSendMessage(true);
      setChangeBrightness((prev) => !prev);
    }
  };

  const handleChangeSpeed = (value) => {
    const buttons = buttonsRef.current; // get latest buttons value
    const key =
      buttons?.[0]?.digit === 0
        ? "rgbSpeed1"
        : buttons?.[0]?.digit === 1
          ? "rgbSpeed2"
          : null;

    if (key) {
      setButtonStates((prev) => ({
        ...buttonStatesRef.current,
        [key]: Number(value),
      }));
      setSendMessage(true);
      setChangeSpeed((prev) => !prev);
    }
  };

  const handleChangeNameButton = (button) => {
    const onSubmitFunc = ({ button, name }) => {
      UpdateEquipmentButton({
        equipment_button_id: button.id,
        name: name,
        digit: button.digit,
        icon: button.icon,
      }).then((res) => {
        if (res.status == 200) {
          setEditedButtonName("");
          setEditButton(null);
          SuccessToast("با موفقیت ثبت شد");

          const index = equipmentButtons.findIndex(
            (item) => item.id === button.id,
          );

          if (index !== -1) {
            const updatedButtons = [...equipmentButtons];
            updatedButtons[index] = {
              ...updatedButtons[index],
              name: name,
            };

            setEquipmentButtons(updatedButtons);
          }
        }
      });
    };
    const newOptions = {
      name: button.name,
      onSubmit: (newName) => {
        onSubmitFunc({ button, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };
  const handleSetEffect = (effectType, color1, color2) => {
    if (buttons.length) {
      let device = devices.find((d) => d.id == buttons[0].device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
        let buffer = new ArrayBuffer(17);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 6;
        asciiCode[9] = buttons[0].digit + 1;
        asciiCode[10] = effectType;
        asciiCode[11] = color1[0];
        asciiCode[12] = color1[1];
        asciiCode[13] = color1[2];
        asciiCode[14] = color2[0];
        asciiCode[15] = color2[1];
        asciiCode[16] = color2[2];

        let message = device.bridge_device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else {
        let buffer = new ArrayBuffer(9);
        let asciiCode = new Uint8Array(buffer);
        // let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
        // if (buttons[0].digit == 0) {
        //   selectedChannel = ["0", "0", "0", "0", "0", "1", "1", "1"];
        // } else if (buttons[0].digit == 1) {
        //   selectedChannel = ["0", "0", "1", "1", "1", "0", "0", "0"];
        // }
        asciiCode[0] = 6;
        // asciiCode[1] = parseInt(selectedChannel.join(""), 2);
        asciiCode[1] = buttons[0].digit + 1;
        asciiCode[2] = effectType;
        asciiCode[3] = color1[0];
        asciiCode[4] = color1[1];
        asciiCode[5] = color1[2];
        asciiCode[6] = color2[0];
        asciiCode[7] = color2[1];
        asciiCode[8] = color2[2];

        let message = device.internet_token;

        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }

      setSendMessage(true);
      // setChangeColor(false);
    }
  };

  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id === equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  return (
    <div
      className="card h-100"
      style={{ backgroundColor: "#fff0", boxShadow: "none" }}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
        style={{ zIndex: "1" }}
      >
        <h5 className={editEquipmentName ? "d-none" : ""}>
          {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
        </h5>
        <div
          className={editEquipmentName ? "mt-2 d-block" : "d-none"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div>
            <input
              id="smallInput"
              className="form-control form-control-sm text-center"
              name="room_name"
              type="text"
              placeholder="نام تجهیز را وارد کنید"
              value={editedEquipmentName}
              onChange={(e) => setEditedEquipmentName(e.target.value)}
            />
          </div>
          <div className="mt-1">
            <button
              type="button"
              className="btn btn-xs btn-success-app submit-add-room me-2"
              onClick={() =>
                handleChangeEquipmentName(
                  equipments.find((eq) => eq.id == eq_id)?.id,
                )
              }
            >
              ثبت
            </button>
            <button
              type="button"
              className="btn btn-xs btn-success-app"
              onClick={(e) => setEditEquipmentName(false)}
            >
              انصراف
            </button>
          </div>
        </div>
        <div>
          {authUser.is_admin ? (
            <>
              <button
                type="button"
                className="btn btn-success-app btn-icon me-2"
                style={{ borderColor: "rgb(0, 165, 148)" }}
                onClick={() => handleRemoveEquipment(selectedEquipment.id)}
              >
                <i className="bx bx-trash"></i>
              </button>
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEquipmentsListModal(true);
                      }}
                    >
                      افزدون تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to={
                        "/room/select-device/" +
                        room_id +
                        "/" +
                        eq_id +
                        "/" +
                        eq_type
                      }
                    >
                      افزدون کانال به تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={() =>
                        handleChangeEquipmentName(
                          equipments.find((eq) => eq.id == eq_id)?.id,
                        )
                      }
                    >
                      تغییر نام تجهیز
                    </Link>
                  </li>
                </ul>
              </div>
            </>
          ) : null}

          {/* <BackButton url={"/room/" + room_id} /> */}
        </div>
      </div>
      <div
        className={
          devices.find((d) => d.id == buttons?.[0]?.device_id)
            ? "card-body scrollbar mt-sm-2"
            : "d-none"
        }
        style={{ paddingBottom: "10rem" }}
      >
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1rem" }}> */}
        <div
          className="rgb"
          style={{
            boxShadow: sendMessage
              ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
              : "",
          }}
        >
          {authUser.is_admin ? (
            <div className="d-flex flex-nowrap justify-content-between">
              <div
                className="btn-group d-inline-block"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <button
                  type="button"
                  className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu ">
                  <li
                    onClick={() => {
                      handleChangeNameButton(buttons?.[0]);
                    }}
                  >
                    <a className="dropdown-item">تغییر نام</a>
                  </li>
                </ul>
              </div>
              <div className="text-center rgb-info">
                <div className="text-center">
                  <p
                    className={
                      editButton == buttons?.[0]?.id
                        ? "d-none"
                        : "text-center p-0 m-0 d-block"
                    }
                  >
                    {buttons?.[0]?.name}
                  </p>
                  <div
                    className={
                      editButton == buttons?.[0]?.id ? "mt-2 d-block" : "d-none"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div>
                      <input
                        id="smallInput"
                        className="form-control form-control-sm text-center"
                        name="room_name"
                        type="text"
                        placeholder="نام کلید را وارد کنید"
                        value={editedButtonName}
                        onChange={(e) => setEditedButtonName(e.target.value)}
                      />
                    </div>
                    <div className="mt-1">
                      <button
                        type="button"
                        className="btn btn-xs btn-success-app submit-add-room me-2"
                        onClick={() => handleChangeNameButton(buttons?.[0])}
                      >
                        ثبت
                      </button>
                      <button
                        type="button"
                        className="btn btn-xs btn-success-app mt-1"
                        onClick={(e) => setEditButton(null)}
                      >
                        انصراف
                      </button>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <span style={{ fontSize: "11px" }}>
                    C{buttons?.[0] ? buttons?.[0].digit + 1 : "-"}-S/
                    {buttons?.[0]
                      ? devices.find((d) => d.id == buttons[0].device_id)
                          ?.serial
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
          ) : null}

          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(0, 0, 0)}
              >
                <img src="/assets/img/app-icons/zl.png" alt="" />
              </div>
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(255, 255, 255)}
              >
                <img src="/assets/img/app-icons/v8.png" alt="" />
              </div>
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(255, 255, 0)}
              >
                <img src="/assets/img/app-icons/_o.png" alt="" />
              </div>
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(255, 0, 255)}
              >
                <img src="/assets/img/app-icons/hM.png" alt="" />
              </div>
            </div>
            <div>
              <RGBColorPicker
                color={
                  buttons?.[0]?.digit === 0
                    ? buttonStates[0] || buttonStates[1] || buttonStates[2]
                      ? (() => {
                          const maxValue = Math.max(
                            buttonStates[0],
                            buttonStates[1],
                            buttonStates[2],
                          );
                          return {
                            r: (buttonStates[0] / maxValue) * 255,
                            g: (buttonStates[1] / maxValue) * 255,
                            b: (buttonStates[2] / maxValue) * 255,
                            a: 1,
                          };
                        })()
                      : { r: 255, g: 255, b: 255, a: 1 }
                    : buttons?.[0]?.digit === 1
                      ? buttonStates[3] || buttonStates[4] || buttonStates[5]
                        ? (() => {
                            const maxValue = Math.max(
                              buttonStates[3],
                              buttonStates[4],
                              buttonStates[5],
                            );
                            return {
                              r: (buttonStates[3] / maxValue) * 255,
                              g: (buttonStates[4] / maxValue) * 255,
                              b: (buttonStates[5] / maxValue) * 255,
                              a: 1,
                            };
                          })()
                        : { r: 255, g: 255, b: 255, a: 1 }
                      : { r: 255, g: 255, b: 255, a: 1 }
                }
                setColor={handleClickChangeColor}
              />
            </div>
            <div className="d-flex flex-column">
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(255, 0, 0)}
              >
                <img src="/assets/img/app-icons/gN.png" alt="" />
              </div>
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(0, 255, 0)}
              >
                <img src="/assets/img/app-icons/gQ.png" alt="" />
              </div>
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(0, 0, 255)}
              >
                <img src="/assets/img/app-icons/ht.png" alt="" />
              </div>
              <div
                className="icons mb-1"
                onClick={() => handleClickChangeColor(0, 255, 255)}
              >
                <img src="/assets/img/app-icons/hR.png" alt="" />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="icons">
              <img src="/assets/img/app-icons/CE.png" alt="" />
            </div>
            <div className="slider">
              <LinearSlider
                value={
                  buttons?.[0]?.digit === 0
                    ? buttonStates?.rgbBrightness1
                    : buttons?.[0]?.digit === 1
                      ? buttonStates?.rgbBrightness2
                      : 0
                }
                setValue={(value) => handleChangeBrightness(value)}
              />
            </div>
            <div className="icons">
              <img src="/assets/img/app-icons/4W.png" alt="" />
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [0, 0, 255], [0, 255, 255])}
              >
                <img src="/assets/img/app-icons/ki.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [255, 0, 0], [255, 0, 255])}
              >
                <img src="/assets/img/app-icons/zB.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [0, 255, 0], [0, 0, 255])}
              >
                <img src="/assets/img/app-icons/9A.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [255, 0, 0], [0, 0, 255])}
              >
                <img src="/assets/img/app-icons/gN.png" alt="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [255, 0, 255], [0, 0, 0])}
              >
                <img src="/assets/img/app-icons/EF.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [0, 255, 0], [0, 0, 0])}
              >
                <img src="/assets/img/app-icons/db.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [255, 0, 0], [0, 0, 0])}
              >
                <img src="/assets/img/app-icons/zG.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [0, 0, 255], [0, 0, 0])}
              >
                <img src="/assets/img/app-icons/0i.png" alt="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() =>
                  handleSetEffect(
                    buttonStates?.audioEffect ? 5 : 4,
                    [0, 0, 0],
                    [0, 0, 0],
                  )
                }
              >
                {buttonStates?.audioEffect ? (
                  <img src="/assets/img/app-icons/c9.png" alt="" />
                ) : (
                  <img src="/assets/img/app-icons/y6.png" alt="" />
                )}
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(3, [0, 0, 0], [0, 0, 0])}
              >
                <img src="/assets/img/app-icons/a3.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [255, 255, 255], [0, 0, 0])}
              >
                <img src="/assets/img/app-icons/c7.png" alt="" />
              </div>
            </div>
            <div className="col-3">
              <div
                className="icons me-3 mx-sm-3 mt-1"
                onClick={() => handleSetEffect(2, [255, 255, 0], [0, 0, 0])}
              >
                <img src="/assets/img/app-icons/8v.png" alt="" />
              </div>
            </div>
          </div>
          {/* <div className="d-flex flex-wrap justify-content-center"></div> */}
          <div className="d-flex justify-content-between">
            <div className="icons">
              <img src="/assets/img/app-icons/3y.png" alt="" />
            </div>
            <div className="slider">
              <LinearSlider
                value={
                  buttons?.[0]?.digit === 0
                    ? buttonStates?.rgbSpeed1
                    : buttons?.[0]?.digit === 1
                      ? buttonStates?.rgbSpeed2
                      : 0
                }
                setValue={(value) => handleChangeSpeed(value)}
              />
            </div>
            <div className="icons">
              <img src="/assets/img/app-icons/1U.png" alt="" />
            </div>
          </div>

          <div
            className="w-100"
            style={{
              height: "20px",
              backgroundColor:
                buttons?.[0]?.digit === 0
                  ? `rgb(${buttonStates[0]},${buttonStates[1]},${buttonStates[2]})`
                  : buttons?.[0]?.digit === 1
                    ? `rgb(${buttonStates[3]},${buttonStates[4]},${buttonStates[5]})`
                    : "",
              borderRadius: "25px",
            }}
          ></div>
        </div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(RGB);
